import React from 'react';
import useCheckPermissions from '../../../../hooks/auth/useCheckPermission';
import { PERMISSIONS } from '../../../../constants/auth';
import { Checkbox } from '../../../../components/ui';

type BypassUnsubscriptionCheckboxProps = {
  checked: boolean | null,
  setChecked: (checked: boolean) => void,
};

export default function BypassUnsubscriptionCheckbox(
  props: BypassUnsubscriptionCheckboxProps,
) {
  const { checked, setChecked } = props;
  const { userCheckPermission } = useCheckPermissions();
  const userHasPermission = userCheckPermission(
    PERMISSIONS.UNSUBSCRIBABLE_EDITOR,
  );
  return (
    <Checkbox
      checked={!!checked}
      disabled={!userHasPermission}
      onChange={() => setChecked(!checked)}
    >
      Bypass Unsubscription
    </Checkbox>
  );
}
